import React from "react"
import { Block } from "baseui/block"
import { H1, H2 } from "baseui/typography"
import { StyledLink } from "baseui/link"
import PackageCollection from "./PackageCollection"
import PostCollection from "../components/PostCollection"
import TextComboRenderer from "./TextComboRenderer"
import ContentCollection from "./ContentCollection"
import { Link } from "gatsby-plugin-intl"

type ShelfRendererProps = {
  shelf: {
    contentType: string
    packages?: any[]
    posts?: any[]
    title: string
    tone?: string
    background?: string
    textAlignment?: string
    description?: string
    image?: string
    backgroundColor?: string
    withAds?: boolean
    contents?: any[]
    viewMoreLink?: string
  }
}

const ShelfRenderer = ({
  shelf: {
    contentType,
    packages,
    posts,
    title,
    tone = "dark",
    backgroundColor,
    background,
    textAlignment,
    description,
    image,
    withAds,
    contents,
    viewMoreLink,
  },
}: ShelfRendererProps) => {
  const shelfBottomMargin = ["20px", "20px", "40px", "40px"]
  const shelfTopMargin = ["30px", "30px", "30px", "30px"]

  return (
    <Block
      display={"flex"}
      alignItems={"center"}
      flexDirection={"column"}
      $style={{
        background:
          background !== ""
            ? `${backgroundColor} url('${background}') center/cover no-repeat`
            : `#2E363D`,
      }}
      width={"100%"}
    >
      {contentType === "Package" && (
        <Block
          maxWidth={"1600px"}
          width={"95%"}
          marginTop={shelfTopMargin}
          marginBottom={shelfBottomMargin}
          display={"flex"}
          flexDirection={"column"}
        >
          <H1 color={tone === "dark" ? "white" : "black"} alignSelf={"center"}>
            {title}
          </H1>
          <PackageCollection packages={packages} tone={tone} />
        </Block>
      )}
      {contentType === "Post" && (
        <Block
          maxWidth={"1600px"}
          width={"95%"}
          marginTop={shelfTopMargin}
          marginBottom={shelfBottomMargin}
          display={"flex"}
          flexDirection={"column"}
        >
          <Block display={"flex"} justifyContent={"space-between"}>
            <H2
              marginTop={"0px"}
              marginBottom={["24px", "30px", "30px", "30px"]}
              marginLeft={["0px", "8px", "10px", "10px"]}
              color={tone === "dark" ? "white" : "black"}
            >
              {title}
            </H2>
            {viewMoreLink && (
              <Block as={Link} to={viewMoreLink} $style={{ marginTop: "8px" }}>
                <StyledLink>View More</StyledLink>
              </Block>
            )}
          </Block>
          <PostCollection posts={posts} withAds={withAds} />
        </Block>
      )}
      {contentType === "textCombo" && (
        <Block backgroundColor={backgroundColor} width={"100%"}>
          <Block
            maxWidth={"1600px"}
            width={"95%"}
            marginLeft={"auto"}
            marginRight={"auto"}
            marginTop={shelfTopMargin}
            marginBottom={shelfBottomMargin}
          >
            <TextComboRenderer
              align={textAlignment}
              content={description}
              img={image}
            />
          </Block>
        </Block>
      )}
      {contentType === "Content" && (
        <Block
          width={"100%"}
          marginTop={shelfTopMargin}
          marginBottom={shelfBottomMargin}
          display={"flex"}
          flexDirection={"column"}
        >
          <H2
            width={"100%"}
            maxWidth={"1600px"}
            margin={"auto"}
            color={tone === "dark" ? "white" : "black"}
            alignSelf={"flex-start"}
          >
            {title}
          </H2>
          <Block>
            <ContentCollection
              contents={contents}
              landscape={title === "Sport NOW!"}
            />
          </Block>
        </Block>
      )}
    </Block>
  )
}

export default ShelfRenderer
